<div class="dashboard-header">
  <div class="dashboard-info">
    <h2>Proctoring Configuration</h2>
    <p>
      Named proctoring configurations control browser and device restrictions,
      capture requirements, recording, and monitoring.
    </p>
  </div>

  <button
    class="add-assessment-btn"
    routerLink="/proctoring-dashboard/configuration"
    *hasPermission="PermissionForStudents.PROCTORING_CREATE"
  >
    <i class="bi bi-plus-lg"></i>
    Add Configuration
  </button>
</div>

<ng-container *ngIf="isInitialLoad; else showPage">
  <div class="app-spinner">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</ng-container>

<ng-template #showPage>
  <ng-container *ngIf="configData.length > 0 || searchText; else showMessage">
    <hr class="dashboard-divider" />
    <div class="table-wrapper">
      <div class="table-filters">
        <div class="search-row">
          <div class="search-box">
            <i class="fa fa-search" *ngIf="!searchText"></i>
            <i *ngIf="searchText" class="bi bi-x" (click)="searchText = ''; onSearchChange()" style="cursor: pointer; font-size: 1.2rem; z-index: 10;"></i>
            <input
              type="text"
              placeholder="Search by proctoring configuration ..."
              [(ngModel)]="searchText"
              (ngModelChange)="onSearchChange()"
            />
          </div>
        </div>
      </div>

      <div class="report-table">
        <div class="table-responsive" [class.menu-open]="openMenuIndex !== null">
        <table>
          <thead>
            <tr>
              <th>
                Configuration Name
                <span class="material-icons sort-icon" (click)="sortBy('name')"> swap_vert </span>
              </th>

              <th>
                Description
                <span class="material-icons sort-icon" (click)="sortBy('description')"> swap_vert </span>
              </th>

              <th>
                Status
                <span class="material-icons sort-icon" (click)="sortBy('isEnabled')"> swap_vert </span>
              </th>

              <th>
                Last updated
                <span class="material-icons sort-icon" (click)="sortBy('updatedAt')"> swap_vert </span>
              </th>

              <th>
                Created On
                <span class="material-icons sort-icon" (click)="sortBy('createdAt')"> swap_vert </span>
              </th>

              <th>
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngIf="isLoading">
              <td colspan="6" style="padding: 40px 0; text-align: center;">
                <mat-spinner diameter="50" style="margin: 0 auto;"></mat-spinner>
              </td>
            </tr>
            <ng-container *ngIf="!isLoading && configData.length > 0">
            <tr *ngFor="let config of configData; let i = index">
              <td>
                <span [matTooltip]="config.name">
                {{ (config.name || '').length > 20 ? ((config.name || '') | slice:0:20) + '...' : config.name || '-' }}
                 <ng-container  *ngIf="config.isDefault">
                  <span class="badge-blue">Default</span>
                </ng-container>
                </span>
              </td>

              <td>
                <span [matTooltip]="config.description">
                {{ (config.description || '').length > 30 ? ((config.description || '') | slice:0:30) + '...' : config.description  || '-'}}
                </span>
              </td>

              <td>
                <span
                  class="badge"
                  [ngClass]="{
                    success: config.isEnabled,
                    warning: !config.isEnabled,
                  }"
                >
                  <span class="dot"></span>
                  {{ config.isEnabled ? "Active" : "Inactive" }}
                </span>
              </td>
              <td>
                {{ config.updatedAt | date: "dd MMM yyy" }}
              </td>
              <td>
                {{ config.createdAt | date: "dd MMM yyy" }}
              </td>

              <td class="action-cell">
                <!-- <ng-container *hasPermission="PermissionForStudents.PROCTORING_READ">
                <a class="view-report" (click)="goToConfigDetailPage(config.configId)">
                  <i class="bi bi-eye"></i>
                  View
                </a>
                </ng-container> -->

                <ng-container *hasPermission="PermissionForStudents.PROCTORING_UPDATE">
                <span class="ms-3" (click)="goToConfigDetailPage(config.configId)">
                  <i class="bi bi-pencil"></i>
                  Edit
                </span>
                </ng-container>

                <!-- <div class="action-menu">
                  <i class="bi bi-three-dots" (click)="toggleMenu(i, $event)">
                  </i>

                  <div class="menu" *ngIf="openMenuIndex === i"> -->
                    <!-- <button type="button" (click)="openEnablePopup($event)">
                      Enable
                    </button> -->
                <ng-container  *ngIf="!config.isDefault">
                  <span (click)="openDeleteDialogBox(config.configId,config.name)" *hasPermission="PermissionForStudents.PROCTORING_DELETE">
                    <i class="bi bi-trash"></i> Delete</span>
              </ng-container>
                  <!-- </div>
                </div> -->
              </td>
            </tr>
            </ng-container>
            <tr *ngIf="!isLoading && configData.length === 0">
              <td colspan="6">
                <div class="empty-state" style="padding: 40px; text-align: center; color: #64748b; font-size: 14px;">
                  No result found with this name. Please try searching with another name.
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        </div>

        <div class="table-pagination" *ngIf="configData.length > 0">
          <div class="pagination-left">
            Showing <b>{{ startRecord }}-{{ endRecord }}</b> of
            <b>{{ total }}</b>

            <span>Rows per page</span>

            <select [(ngModel)]="pageSize" (change)="changePageSize()">
              <option [ngValue]="5">5</option>
              <option [ngValue]="10">10</option>
              <option [ngValue]="15">15</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="100">100</option>
            </select>
          </div>

          <div class="pagination-right">
            <button [disabled]="currentPage === 1" (click)="previousPage()">
              Previous
            </button>

            <span> Page 
              <select class="pagination-page-select" [(ngModel)]="currentPage" (ngModelChange)="goToPage($event)">
                <option *ngFor="let page of pagesArray" [ngValue]="page">{{ page }}</option>
              </select>
              of {{ displayTotalPages }} 
            </span>

            <button
              [disabled]="currentPage === totalPages"
              (click)="nextPage()"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #showMessage>
    <div class="empty-state" style="padding: 40px; text-align: center; color: #64748b; font-size: 14px;">No configuration available</div>
  </ng-template>
</ng-template>
